export default function EmptyState({ title, desc, icon: Icon }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-24 px-6" data-testid="empty-state">
      <div className="w-16 h-16 rounded-full border border-[rgba(198,137,158,0.3)] flex items-center justify-center mb-6">
        {Icon ? <Icon className="w-6 h-6 text-[#C6899E]" /> : <span className="font-serif text-2xl text-[#C6899E]">U</span>}
      </div>
      <h3 className="font-serif text-2xl text-[#3D3238] mb-2">{title}</h3>
      <p className="text-[#9C8F94] max-w-sm">{desc}</p>
    </div>
  );
}
